var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "btn-group mb-2" },
        _vm._l(_vm.enabledSlottedTabs, function(slottedTab) {
          return _c(
            "TabButton",
            {
              key: slottedTab.id,
              attrs: { tab: slottedTab.id },
              model: {
                value: _vm.tab,
                callback: function($$v) {
                  _vm.tab = $$v
                },
                expression: "tab"
              }
            },
            [_vm._v("\n      " + _vm._s(slottedTab.title) + "\n    ")]
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "TabSlot",
        {
          attrs: {
            id: "general",
            title: _vm.getTableTitle("general"),
            order: 0
          }
        },
        [
          _c("TabGeneral", {
            attrs: {
              group: _vm.group,
              users: _vm.allUsers,
              groupSelector: _vm.groupSelector,
              hidePinned: _vm.hidePinned
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "generalNameLabel",
                  fn: function({ group }) {
                    return [_vm._t("generalNameLabel", null, { group: group })]
                  }
                },
                {
                  key: "generalAfter",
                  fn: function({ group }) {
                    return [_vm._t("generalAfter", null, { group: group })]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "TabSlot",
        {
          attrs: { id: "users", title: _vm.getTableTitle("users"), order: 10 }
        },
        [
          _c("TabUsers", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "users",
                expression: "tab === 'users'"
              }
            ],
            attrs: {
              group: _vm.group,
              groupSelector: _vm.groupSelector,
              allUsers: _vm.allUsers
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "userButtonsBefore",
                  fn: function({ groupUser }) {
                    return [
                      _vm._t("userButtonsBefore", null, {
                        groupUser: groupUser
                      })
                    ]
                  }
                },
                {
                  key: "userButtonsAfter",
                  fn: function({ groupUser }) {
                    return [
                      _vm._t("userButtonsAfter", null, { groupUser: groupUser })
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "TabSlot",
        {
          attrs: {
            id: "usersExternal",
            title: _vm.getTableTitle("usersExternal"),
            order: 20
          }
        },
        [
          _c("TabUsersExternal", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tab === "usersExternal",
                expression: "tab === 'usersExternal'"
              }
            ],
            attrs: {
              group: _vm.group,
              groupSelector: _vm.groupSelector,
              availableSalutations:
                _vm.availableSalutationsIncludingEditingGroup,
              hideDisabled: _vm.hideExternalUserDisabled,
              hideMassSelection: _vm.hideMassSelection,
              allowNoEmailForExternalUsers: _vm.allowNoEmailForExternalUsers
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "externalUserButtonsBefore",
                  fn: function({ groupUserExternal }) {
                    return [
                      _vm._t("externalUserButtonsBefore", null, {
                        groupUserExternal: groupUserExternal
                      })
                    ]
                  }
                },
                {
                  key: "externalUserButtonsAfter",
                  fn: function({ groupUserExternal }) {
                    return [
                      _vm._t("externalUserButtonsAfter", null, {
                        groupUserExternal: groupUserExternal
                      })
                    ]
                  }
                },
                {
                  key: "selectedExternalUserButtonsBefore",
                  fn: function({ groupUserExternals }) {
                    return [
                      _vm._t("selectedExternalUserButtonsBefore", null, {
                        groupUserExternals: groupUserExternals
                      })
                    ]
                  }
                },
                {
                  key: "selectedExternalUserButtonsAfter",
                  fn: function({ groupUserExternals }) {
                    return [
                      _vm._t("selectedExternalUserButtonsAfter", null, {
                        groupUserExternals: groupUserExternals
                      })
                    ]
                  }
                },
                {
                  key: "externalUserSelectModalTabs",
                  fn: function() {
                    return [_vm._t("externalUserSelectModalTabs")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("editModalTabs", null, { group: _vm.group })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }